import { useQuery } from "@tanstack/react-query";
import { axios } from "../../../shared/lib/axios";
import _cookies from "../../../shared/utils/_cookies";
import { parseCourseStatus } from "../utils/parseCourseStatus";

export const getMandatoryCourses = async ({ studentId }) => {
  const res = await axios.middleware("/aluno.asmx/disciplinas_obrigatorias", {
    params: {
      alunoid: studentId,
    },
  });
  return res[0].data.map((course) => {
    return { ...course, ...parseCourseStatus(course) };
  });
};

export const useMandatoryCourses = ({ config, params = {} } = {}) => {
  return useQuery({
    ...config,
    queryKey: [
      "mandatoryCourses",
      { studentId: _cookies.getItem("auth").user.alunoid, ...params },
    ],
    queryFn: () =>
      getMandatoryCourses({
        studentId: _cookies.getItem("auth").user.alunoid,
        ...params,
      }),
  });
};
